import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            四大核心能力，让每日大赛黑料成为你首选的吃瓜阵地
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="p-5 md:p-6 rounded-lg bg-background-200/70 border border-background-300/50 text-center group hover:border-primary-500/30 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feature.icon} text-2xl md:text-3xl text-primary-400`}></i>
              </div>
              <h3 className="text-foreground-100 font-semibold text-sm md:text-base mb-2.5 font-heading">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}